import UniversalLoginRedirect from 'components/auth/UniversalLoginRedirect';
import SignupTermsAcceptance from 'components/auth/SignupTermsAcceptance';

export default function SignUpDefault() {
  return (
    <UniversalLoginRedirect signup>
      <SignupTermsAcceptance />
    </UniversalLoginRedirect>
  );
}
